import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { getFirebase } from 'react-redux-firebase';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  firebaseui: {
    height: "400px"
  }
}));

const Login = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const firebase = getFirebase();

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        navigate('/');
      }
    });
    return () => unsubscribe();
  }, [firebase, navigate]);

  // Configure FirebaseUI.
  const uiConfig = {
    signInFlow: 'popup',
    signInSuccessUrl: '/', // This is ignored when signInSuccessWithAuthResult returns false
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: (authResult) => {
        const isNewUser = authResult.additionalUserInfo.isNewUser;
        if (isNewUser) {
          window.location.href = `https://${window.location.hostname}/documents/getting-started`;
        } else {
          window.location.href = `https://${window.location.hostname}/devices`;
        }
        return false; // Prevent automatic redirect
      },
      uiShown: () => {}
    }
  };

  return (
    <main>
      <Container>
        <h1>Login</h1>
        <Box id="firebaseui-auth-container" className={classes.firebaseui}>
          <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        </Box>
      </Container>
    </main>
  );
};

export default Login;
